import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Welche Zahlungsmethoden kann ich nutzen?",
    a: "Alle gängigen: Kredit- und Debitkarten (Visa, Mastercard, Amex), PayPal, Apple Pay und Google Pay. Alles läuft über die sichere Kaufabwicklung von Stripe, deine Kartendaten landen nie auf dieser Seite.",
  },
  {
    q: "Wie erhalte ich mein E-Book?",
    a: "Sofort nach der Zahlung bekommst du eine E-Mail mit deinem persönlichen Download-Link. Der Link funktioniert 3 Mal und ist 7 Tage gültig, also speichere die Datei direkt auf deinem Gerät ab.",
  },
  {
    q: "Was ist im Trilogie-Bundle enthalten?",
    a: "Alle drei Bände zum Vorteilspreis von 49,99 € statt 59,97 €. Band 1 erhältst du sofort als Download, Band 2 und 3 folgen automatisch per E-Mail, sobald sie erscheinen.",
  },
  {
    q: "In welcher Sprache erscheint das Buch?",
    a: "Schattenpsyche · Ein Profiler-Handbuch für den Alltag erscheint auf Deutsch. Neuigkeiten zu Band 2 und 3 gibt es zuerst auf TikTok unter @schatten_psyche_.",
  },
];

export const FaqSection = () => (
  <section id="faq" className="relative py-24 lg:py-36" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mb-12 text-center"
      >
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-slate-400 mb-4">
          Verhör
        </p>
        <h2 className="font-cinzel text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight">
          Häufige Fragen
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
      >
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="glass rounded-xl px-6 border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-typewriter text-base sm:text-lg text-paper hover:text-white text-left py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 text-sm sm:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
